import React from 'react';

/** Non-blocking status when the latest pricing request failed; last valid price remains. */
const PricingStatus: React.FC<{error: string}> = ({error}) => {
    if (!error) {
        return null;
    }

    return (
        <div
            role="status"
            aria-live="polite"
            className="text-danger"
            style={{marginTop: 8, fontSize: 13, fontWeight: 400, flexBasis: '100%'}}
        >
            {error}
        </div>
    );
};

export default PricingStatus;
